export const SEARCH_PARAMS = {
  unit: "unit",
  program: "program",
  employee: "employee",
  year: "year",
  status: "status",
  myStatus: "myStatus",
};
